import { TabelaDePreco } from '@/models'
import moment from 'moment'

export const tabelaDePrecoEstaVigente = (tabelaDePreco: TabelaDePreco): boolean =>
	moment().isSameOrAfter(moment(`${tabelaDePreco.inicioVigencia} 00:00:00`, 'YYYY-MM-DD HH:mm:ss'))
		&& moment().isSameOrBefore(moment(`${tabelaDePreco.fimVigencia} 23:59:59`, 'YYYY-MM-DD HH:mm:ss'))
